<script setup lang="ts">
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'
import i18n from '@/VueI18n'

const title = computed(() => i18n.t('fireRiskDashboardNoRecords'))

const subtitle = computed(() => i18n.t('fireRiskDashboardWaitForAlerts'))

const icon = computed(() => 'fa6-solid:folder-open')
</script>

<template>
	<div class="flex items-center w-full flex-col gap-2 p-16">
		<Icon
			:icon="icon"
			class="text-4xl text-gray-dark"
		/>
		<p class="text-default">{{ title }}</p>
		<p class="text-default text-center">{{ subtitle }}</p>
	</div>
</template>
